/**
 * REKO-9 warianty na żywo — wspólne narzędzia tabeli „Porównaj z podobnymi” (karta produktu,
 * assets/quick-comparison-table.js) i porównywarki na liście produktów (assets/compare.js).
 * Dane kolumny: JSON ze snippetu quick-comparison-table-variants (format opisany w snippecie).
 * Nie dotyka plików bazowych Hyper — podmienia tylko komórki, cenę, zdjęcie i linki kolumny.
 */
if (!window.QctVariants) {
  window.QctVariants = {
    /** JSON wariantów z elementu (komórka nagłówka albo kontener „Oglądasz”). */
    read(root) {
      const script = root && root.querySelector('script[data-qct-variants]');
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        console.error(e);
        return null;
      }
    },

    find(data, variantId) {
      if (!data || !Array.isArray(data.v)) return null;
      return data.v.find((variant) => String(variant.id) === String(variantId)) || null;
    },

    /** Komórka wartości: pusta = „—” (jak w Liquid). */
    setCell(cell, html) {
      if (!cell) return;
      const filled = typeof html === 'string' && html !== '';
      cell.innerHTML = filled ? html : '—';
      cell.classList.toggle('qct-cell--empty', !filled);
      cell.toggleAttribute('data-qct-filled', filled);
      if (!filled) cell.classList.remove('qct-cell--diff');
    },

    /** Nagłówek kolumny: cena, zdjęcie (własne wariantu albo produktu), linki ?variant=, select. */
    applyHeader(td, data, variant) {
      if (!td || !variant) return;

      const price = td.querySelector('.f-price');
      if (price) {
        price.classList.toggle('f-price--on-sale', Boolean(variant.c));
        price.classList.toggle('f-price--sold-out', !variant.a);
        price.classList.remove('f-price--no-compare');
        price
          .querySelectorAll('.f-price__regular .f-price-item--regular, .f-price__sale .f-price-item--sale')
          .forEach((item) => {
            item.textContent = variant.p;
          });
        const compareAt = price.querySelector('.f-price__sale s');
        if (compareAt) compareAt.textContent = variant.c || '';
      }

      const image = td.querySelector('.media-wrapper img');
      const source = variant.i || data.d;
      if (image && source) {
        image.srcset = `${source[0]} 170w, ${source[1]} 340w`;
        image.src = source[1];
      }

      td.querySelectorAll('[data-qct-link]').forEach((link) => {
        link.href = `${data.u}?variant=${variant.id}`;
      });

      const picker = td.querySelector('select[data-qct-picker]');
      if (picker && picker.value !== String(variant.id)) picker.value = String(variant.id);

      td.dataset.qctVariant = String(variant.id);
    },

    /**
     * §11: wyrównanie nagłówka kolumn — tytuły (h3) i bloki ceny dostają min-height równą najwyższemu w wierszu,
     * więc ceny stoją w jednej linii, a select wariantu pod ceną (tylko tam, gdzie jest) też w jednej linii.
     * Komórki tabeli nie dzielą siatki, stąd pomiar w JS; przeliczane przy każdej zmianie rozmiaru tabeli.
     */
    alignHeader(table) {
      const row = table && table.querySelector('tr[data-compare-key="info"]');
      if (!row) return;
      [row.querySelectorAll('h3'), row.querySelectorAll('.qct-price')].forEach((nodes) => {
        const list = Array.from(nodes);
        list.forEach((el) => (el.style.minHeight = ''));
        if (list.length < 2) return;
        const max = Math.max(...list.map((el) => el.offsetHeight));
        if (max > 0) list.forEach((el) => (el.style.minHeight = `${max}px`));
      });

      // Porównywarka (desktop): przycisk „Zobacz szczegóły” w jednej linii — w kolumnie bez selecta blok ceny
      // dostaje dodatkowo wysokość selecta. Na telefonie przycisk jest ukryty, więc nic się nie dzieje.
      const picker = Array.from(row.querySelectorAll('.qct-picker')).find((el) => el.offsetHeight > 0);
      if (!picker) return;
      const pickerSpace = picker.offsetHeight + parseFloat(getComputedStyle(picker).marginTop || 0);
      row.querySelectorAll('.qct-price').forEach((price) => {
        const info = price.parentElement;
        const btn = info.querySelector('.btn');
        if (info.querySelector('.qct-picker') || !btn || btn.offsetHeight === 0) return;
        price.style.minHeight = `${parseFloat(price.style.minHeight || price.offsetHeight) + pickerSpace}px`;
      });
    },

    /** Obserwator rozmiaru tabeli (szerokość okna, dodane/usunięte kolumny, pokazanie szuflady). */
    watchHeader(table) {
      if (!table || table.qctObserver || !('ResizeObserver' in window)) return;
      let width = 0;
      table.qctObserver = new ResizeObserver((entries) => {
        const w = Math.round(entries[0].contentRect.width);
        if (w === width) return; // wysokość zmienia samo wyrównanie — reagujemy tylko na szerokość
        width = w;
        this.alignHeader(table);
      });
      table.qctObserver.observe(table);
    },

    /** Wartości kolumny: wiersz po data-compare-key, komórka po indeksie kolumny. */
    applyCells(table, colIndex, data, variant) {
      if (!table || !variant) return;
      data.k.forEach((key, i) => {
        const row = table.querySelector(`tr[data-compare-key="${key}"]`);
        if (row && row.cells[colIndex]) this.setCell(row.cells[colIndex], variant.x[i]);
      });
    },
  };
}
